import React, { useState, useEffect } from "react";
import axios from "axios";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { SectionHeader } from "../global.style";
import Fade from "react-reveal/Fade";
import Heading from "common/components/Heading";
import SectionWrapper from "./slider.style";

// Install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

// Styles for the modal
const customStyles = {
  content: {
    position: "absolute",
    inset: "50% auto auto 50%",
    overflow: "visible",
    borderRadius: "10px",
    border: "2px solid #bc8941",
    outline: "none",
    padding: "3px",
    margin: "0px",
    transform: "translate(-50%, -50%)",
    maxWidth: "48%",
    maxHeight: "80%",
  },
};

const customClose = {
  background: "white",
  position: "absolute",
  color: "#000000",
  borderRadius: "50px",
  right: "-9px",
  width: "25px",
  padding: "0",
  zIndex: "11111",
  boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
};

function Slider() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);
  // const apiUrl = process.env.GATSBY_API_URL;

  // Fetch images from API
  useEffect(() => {
    axios
      .get(`https://radianceadmin.manageprojects.in/api/gallery-images`)
      .then((response) => {
        if (response.data.success && response.data.data.length > 0) {
          setImages(response.data.data[0].images || []);
        }
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, []);

  const openModal = (image) => {
    setSelectedImage(image);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedImage(null);
    setModalIsOpen(false);
  };

  const swiperBreakpoints = {
    767: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  };

  return (
    <SectionWrapper id="successStories" >
      <Fade top>
        <SectionHeader>
          <Heading as="h5" content="Life-changing results" style={{ marginBottom: "0" }} />
          <Heading content="Before and after success stories" />
        </SectionHeader>
      </Fade>
      <div className="myContainer homeSlider flexDirecColumn">
        <Fade bottom>
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            navigation
            autoplay={{ delay: 3000 }}
            breakpoints={swiperBreakpoints}
          >
            {images.map((image, index) => (
              <SwiperSlide key={index}>
                <div className="flexCard" onClick={() => openModal(image)}>
                  <div className="SScard">
                    <img src={image} alt={`Slide ${index + 1}`} />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Fade>
      </div>
      {/* Modal for displaying the selected image */}
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Image Modal">
        <div className="modal-header">
          <button className="close-button" onClick={closeModal} style={customClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        {/* Image Slider */}
        <Swiper spaceBetween={10} slidesPerView={1} navigation loop={true}>
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <img src={image} alt={`Slide ${index + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Modal>
    </SectionWrapper>
  );
}

export default Slider;
